import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuditlogdateComponent } from '../auditlogdate/auditlogdate.component';
import { CompName } from '@shared/helpers/constants';
import { AuthService } from '@shared/services/auth.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  compName: string = CompName.SETTINGS;
  hilVersion: number;
  primeSegVerion: number;
  tibiaSegVersion: string;
  displaySpinner: boolean = true;
  constructor(public dialog: MatDialog,
    private authService: AuthService) {
      this.ssmInfo();     
     }

  ngOnInit(): void {    
  }
  //fetch SSM Parameters for app Verion and Prime Seg Version
  public async ssmInfo(): Promise<void>{
    this.hilVersion = await this.authService.getSSMValue(environment.ssmParams.APPVERSION);
    this.primeSegVerion = await this.authService.getSSMValue(environment.ssmParams.PRIMESEGVERSION);
    this.tibiaSegVersion = await this.authService.getSSMValue(environment.ssmParams.TIBIASEGVERSION);      
    this.displaySpinner = false;  
  }
  openDateRange() {
    let dialogRef = this.dialog.open(AuditlogdateComponent, {
      autoFocus: false,
      id: 'auditDialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

}